import {Dropdown, DropdownItem, DropdownMenu, DropdownTrigger} from "@heroui/react";
import {Icon} from "@iconify/react";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {useWindowSize} from "@uidotdev/usehooks";
import React from "react";
import {SwipeableList, SwipeableListItem, Type} from "react-swipeable-list";
import Content from "../../../components/Content.tsx";
import PButton from "../../../components/PButton.tsx";
import {UserRole} from "../../../constants.ts";
import Header from "../../../Header.tsx";
import {useJwtUser} from "../../../JWTAuthProvider.tsx";
import services from "../../../services";
import {RankingGroup} from "../../../types";
import queryKeys from "../../../utilities/queryKeys.ts";

export const Route = createFileRoute('/_app/running/')({
    component: RouteComponent,
})

function RouteComponent() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const user = useJwtUser();

    const importsQuery = useQuery({
        queryKey: queryKeys.running.getImports(),
        queryFn:  async () => services.running.getImports(),
    })

    const rankingGroupsQuery = useQuery({
        queryKey: queryKeys.running.getRankings(),
        queryFn:  async () => services.running.getRankings(),
    });

    const size = useWindowSize();

    const isSm = (!!size.width && size.width < 640);

    const columns = [];

    return <>
        <Header backUrl={"/running"} />
        <Content>
            <div className="w-full flex justify-between mb-4">
                <Dropdown>
                    <DropdownTrigger>
                        <PButton startContent={<Icon icon="material-symbols-light:trophy-outline" className="text-2xl" />}
                        >
                            Leaderboards
                        </PButton>
                    </DropdownTrigger>
                    <DropdownMenu aria-label="Ranking Tables">
                        {(rankingGroupsQuery.data || []).map((rankingGroup: RankingGroup | any) =>
                            <DropdownItem key={rankingGroup.uid} onPress={() => navigate({to: `/running/leaderboards-results/${rankingGroup.uid}`})}
                            >
                                {rankingGroup.name}
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>

                <div>
                    {user && user.role === UserRole.Master && (<>
                        <PButton className={"ml-2"} color="primary"
                                 startContent={<Icon icon="material-symbols-light:settings-outline" className="text-2xl" />}
                                 onPress={() => navigate({to: '/running/upload/'})}>
                            Manage
                        </PButton>
                    </>)}
                </div>
            </div>
            <article>
                <SwipeableList type={Type.IOS} className={"light:bg-slate-200 rounded-xl p-4 *:mb-2"}>

                    {(importsQuery.data || [])?.map((tournament: any) => (
                        <SwipeableListItem
                            key={tournament.uid}
                            blockSwipe={!isSm}
                            className={"light:bg-gray-100 dark:bg-neutral-700 rounded-xl"}
                        >
                            <div key={tournament.uid} className={"py-1.5 px-4 flex w-full justify-between items-center"}>
                                <span className="flex-1">
                                    {tournament.event_title || tournament.file_name || '???'}<br />
                                </span>
                                <PButton className="mr-1 sm:min-w-10 sm:px-0!" color={"primary"} onPress={() => navigate({to: `/running/results/${tournament.uid}/`})}>
                                    <Icon icon="material-symbols-light:visibility-outline" className="text-2xl" /><span className="sm:hidden">open</span>
                                </PButton>
                            </div>
                        </SwipeableListItem>
                    ))}

                </SwipeableList>

                {importsQuery.data && importsQuery.data.length === 0 && (
                    <div className={"text-center"}>No Races found.</div>
                )}
            </article>
        </Content>
    </>
}
